<template>
  <admin-layout :title="$t('Roles')">
    <div class="px-4 md:px-0">
      <tec-section-title class="mb-6">
        <template #title>{{ $t('Roles') }}</template>
        <template #description>{{ $t('Please review the data in the table below') }}</template>
      </tec-section-title>

      <div class="mb-6 flex justify-between items-center">
        <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
          <label class="block text-gray-700">{{ $t('Trashed') }}:</label>
          <select-input v-model="form.trashed" class="mt-1 w-full">
            <option :value="null" />
            <option value="with">{{ $t('With Trashed') }}</option>
            <option value="only">{{ $t('Only Trashed') }}</option>
          </select-input>
        </search-filter>
        <tec-button :href="route('roles.create')">
          <span>
            <icons name="plus" class="w-5 h-5 lg:mr-2" />
          </span>
          <span class="hidden lg:inline">{{ $t('create_x', { x: $t('Role') }) }}</span>
        </tec-button>
      </div>
      <div class="bg-white rounded-md shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">
            <th class="px-6 pt-6 pb-4">{{ $t('Name') }}</th>
            <th class="px-6 pt-6 pb-4"></th>
          </tr>
          <tr
            :key="role.id"
            v-for="role in roles.data"
            @click="goto(route('roles.edit', role.id))"
            class="hover:bg-gray-100 focus-within:bg-gray-100"
            :class="{ 'cursor-pointer': role.name != 'Super Admin' && $can('update-roles') }"
          >
            <td class="border-t">
              <div class="focus:outline-none px-6 py-4 flex items-center focus:text-indigo-500">
                {{ $t(role.name) }}
                <icons v-if="role.deleted_at" name="trash" class="flex-shrink-0 w-4 h-4 fill-red-400 ml-2" />
              </div>
            </td>
            <td class="border-t w-px">
              <div v-if="role.name != 'Super Admin' && $can('update-roles')" class="focus:outline-none px-4 flex items-center">
                <icons name="chevron-down" class="transform -rotate-90 block w-4 h-4" />
              </div>
              <div v-else></div>
            </td>
          </tr>
          <tr v-if="roles.length === 0">
            <td class="border-t px-6 py-4" colspan="2">{{ $t('There is no data to display.') }}</td>
          </tr>
        </table>
      </div>
      <pagination class="mt-6" :meta="roles.meta" :links="roles.links" />
    </div>
  </admin-layout>
</template>

<script>
import pickBy from 'lodash/pickBy';
import throttle from 'lodash/throttle';
import TecButton from '@/Shared/Button';
import mapValues from 'lodash/mapValues';
import Pagination from '@/Shared/Pagination';
import SelectInput from '@/Shared/SelectInput';
import AdminLayout from '@/Layouts/AdminLayout';
import SearchFilter from '@/Shared/SearchFilter';
import TecSectionTitle from '@/Jetstream/SectionTitle';

export default {
  components: {
    TecButton,
    Pagination,
    AdminLayout,
    SelectInput,
    SearchFilter,
    TecSectionTitle,
  },

  props: {
    roles: Object,
    filters: Object,
  },

  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    };
  },

  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form);
        this.$inertia.get(this.route('roles', Object.keys(query).length ? query : { remember: 'forget' }), {}, { preserveState: true });
      }, 150),
      deep: true,
    },
  },

  methods: {
    goto(link) {
      if (this.$can('update-roles')) {
        this.$inertia.visit(link);
      }
    },
    reset() {
      this.form = mapValues(this.form, () => null);
    },
  },
};
</script>
